import { motion } from "framer-motion";
import { ShieldCheck, Zap, Users, TrendingUp, Clock, BarChart3 } from "lucide-react";

const benefits = [
  { icon: ShieldCheck, title: "Zero Risk", desc: "No sign-up fees, no monthly charges. You only benefit." },
  { icon: Zap, title: "Effortless Setup", desc: "We provide the QR code. Post it, and you're live in minutes." },
  { icon: Users, title: "New Customers", desc: "Access a growing network of AnyWash Pass members in DFW." },
  { icon: TrendingUp, title: "Steady Revenue", desc: "Weekly payouts keep cash flowing without the guesswork." },
  { icon: Clock, title: "No Extra Work", desc: "Customers check in themselves. You just wash and earn." },
  { icon: BarChart3, title: "Growth Potential", desc: "More members = more visits = more income for your business." },
];

const container = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.08 } },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

export default function WhyJoinSection() {
  return (
    <section
      id="why-join"
      data-testid="why-join-section"
      className="py-24 sm:py-32 px-6 sm:px-12 lg:px-24 bg-[#0d0d0d]"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-500 mb-4 block">
            Partner Benefits
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-white">
            Why Join?
          </h2>
        </motion.div>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {benefits.map((b, i) => {
            const Icon = b.icon;
            return (
              <motion.div
                key={i}
                variants={item}
                data-testid={`benefit-card-${i}`}
                className="bg-neutral-900 border border-neutral-800 rounded-2xl p-8 hover:border-neutral-700 transition-colors duration-300"
              >
                <div className="w-10 h-10 rounded-lg bg-blue-600/10 border border-blue-500/20 flex items-center justify-center mb-5">
                  <Icon className="w-5 h-5 text-blue-500" />
                </div>
                <h3 className="text-white font-bold text-lg mb-2">{b.title}</h3>
                <p className="text-neutral-500 text-sm leading-relaxed">{b.desc}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
